export interface CustomerWallet {
  customerPhone: string;
  customerName: string;
  /** الرصيد المتاح في محفظة العميل */
  available: number;
}

export const mockCustomerWallets: CustomerWallet[] = [
  { customerPhone: "0556677889", customerName: "طلال الشمري", available: 30 },
  { customerPhone: "0503334455", customerName: "سلطان بن نايف", available: 120 },
  { customerPhone: "0561239876", customerName: "سعد المطيري", available: 75 },
  { customerPhone: "0509871122", customerName: "محمد الشهري", available: 18 },
  { customerPhone: "0554443322", customerName: "تركي الزهراني", available: 90 },
  { customerPhone: "0551234567", customerName: "بندر العتيبي", available: 60 },
];